// extracted by mini-css-extract-plugin
module.exports = {"btns":"_13uBi0m73RKfkDnegoGLcY","tip":"_33k5wG4WdxSuFxv_n6YIFe","code-btn":"_22WdoScOWc-R9RWe6LBcXn"};